import { useUserData } from "../contexts/UserContext";
import { LogSessionProvider } from "../contexts/LogSessionContext";
import LogSessionWrapper from "../components/LogSessionWrapper";
import { useNavigate } from "react-router-dom";

export default function SurveyStart() {
  const { user, getUserPerson } = useUserData();
  const navigate = useNavigate();

  if (!user) {
    return <div className="p-8 text-center text-red-600">User not found.</div>;
  }

  const person = getUserPerson();
  if (!person) {
    return <div className="p-8 text-center text-red-600">The user does not have any personal record.</div>;
  }
  
  return (
    <LogSessionProvider mode="user" person={person} user={user}>
      <LogSessionWrapper />
    </LogSessionProvider>
  );
}
